<template>
  <div>
    <div v-if="task">
      <vs-card>
        <div class="d-flex align-items-center justify-content-between" slot="header">
          <h5><span>کارگروه</span> {{task.name}} </h5>
          <div>
            <vs-button size="small font-1" @click="settingVisible=!settingVisible">تنظیمات</vs-button>
            <vs-button type="flat" class="d-block ml-4 mr-2" @click="$router.go(-1)">بازگشت</vs-button>
          </div>
        </div>
      </vs-card>
      <vs-card v-show="settingVisible">
        <vs-row style="max-width: 1000px">
          <vs-col vs-xs="12" vs-lg="12" vs-sm="12">
            <valid-times :task-id="Number(task.id)" :items="task.validTimes"></valid-times>
          </vs-col>
          <vs-col vs-xs="12" vs-lg="12" vs-sm="12">
            <constraints :task-id="Number(task.id)"></constraints>
          </vs-col>
        </vs-row>
      </vs-card>
      <task-services></task-services>
    </div>
  </div>
</template>

<script>
  import ValidTimes from "./components/ValidTimes";
  import Constraints from "./components/Constraints";
  import TaskServices from "./components/TaskServices";

  export default {
    name: "TaskShow",
    components: {TaskServices, Constraints, ValidTimes},
    mounted() {
      this.$store.dispatch('getTask', this.$route.params.id)
      this.$store.dispatch('getTaskInfo', this.$route.params.id)
    },
    data() {
      return {
        settingVisible: false,
      }
    },
    computed: {
      task() {
        return this.$store.state.task;
      },
      taskInfo() {
        return this.$store.state.taskInfo;
      },
      services() {
        return this.$store.getters.taskInfoServices;
      }
    },
    methods: {}
  }
</script>

<style scoped>

</style>
